import Joi from "joi";

import { SOURCE_PAGE_TYPES } from "../constants";

export const newsletterSignUp = Joi.object({
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
});
